import { Fragment, useRef } from 'react';
import { Group, Rect } from 'react-konva';
import { Seat } from './Seat';
import { ISeat } from '../../interface/ISeat';
import { ISector } from '../../interface/ISector';
import { ICategoryAssignments } from '../../interface/ICategoryAssignments';
import { SectorObject } from './SectorObject';
import { IBasket } from '../../interface/IBasket';

type input = {
    sectorData: ISector;
    x?: number;
    y?: number;
    onHoverSeat: any;
    onSelectSeat: any;
    onDeselectSeat: any;
    selectedSeatsIds: IBasket[];
    // categoryPrice: any;
    width?: number;
    sessionAssignments: ICategoryAssignments[]
    showPaid: boolean,
    editorMode: boolean
};

export const SectorBlock = ({
    sectorData,
    x,
    y,
    onHoverSeat,
    onSelectSeat,
    onDeselectSeat,
    selectedSeatsIds,
    // categoryPrice,
    sessionAssignments,
    showPaid,
    editorMode = false
}: input) => {
    // useEffect(() => {
    //     console.log(sectorData.capacity > 0)
    // }, [sectorData])
    const containerRef = useRef<any | null>(null);


    if (sectorData.capacity > 0 && sectorData.objectData !== null) {
        return (
            <Group ref={containerRef}>
                <SectorObject
                    sectorData={sectorData}
                    onHover={onHoverSeat}
                    onSelect={onSelectSeat}
                    onDeselect={onDeselectSeat}
                    // categoryPrice={categoryPrice}
                    isSelected={selectedSeatsIds ? selectedSeatsIds.find((item: IBasket) => item.id === sectorData.id) != null : false}
                    sessionAssignments={sessionAssignments} />
            </Group>
        )
    }


    return (
        <Group y={y} x={x} ref={containerRef}>
            <Rect
                // width={width}
                // height={height}
                // fill="white"
                // strokeWidth={1}
                // stroke="lightgrey"
                cornerRadius={5}
            />
            {sectorData.seats &&
                <>
                    {
                        sectorData.seats.filter((seat: ISeat) => seat.seatType !== 13).map((seat: ISeat) =>
                            <Fragment key={seat.id}>

                                {/* {selectedSeatsIds && console.log(selectedSeatsIds.find((item: IBasket) => item.id === seat.id)) != null} */}
                                <Seat
                                    key={seat.id}
                                    seat={seat}
                                    x={seat.posX}
                                    y={seat.posY}
                                    data={seat}
                                    onHover={onHoverSeat}
                                    onSelect={onSelectSeat}
                                    onDeselect={onDeselectSeat}
                                    // categoryPrice={categoryPrice}
                                    isSelected={selectedSeatsIds ? selectedSeatsIds.find((item: IBasket) => item.id === seat.id) != null : false}
                                    sessionAssignments={sessionAssignments}
                                    showPaid={showPaid}
                                    editorMode={editorMode}
                                />
                            </Fragment>
                        )
                    }
                </>
            }
        </Group>
    );
};


